<template>
  <footer class="footer">
    <hr class="divider" />
    <router-link to="/imprint" class="imprint-link">
      Imprint
    </router-link>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
}
</script>

<style scoped>
.footer {
  min-width: 0;
  text-align: center;
}

.divider {
  border: 0;
  border-top: 1px solid var(--color-border);
  margin: 0 0 0.5rem;
}

.imprint-link {
  color: var(--color-primary);
  text-decoration: none;
}

.imprint-link:hover {
  color: var(--color-primary-hover);
}
</style>